function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.707 17.477l.416-.738 4.157.965c.647.158.72.402.72.88h-3.88l-.745-.012c-.369 0-.668-.285-.668-.635v-.46zM0 17.6v-.07c.019-.456.353-.835.801-.947l5.384-.684 5.278-1.16v.93h.284l.578-1.08c.19-.338.446-.524.763-.705a2.33 2.33 0 011.64-.253l3.256.522 2.264-.577c.093-.024.19-.037.291-.037h1.532c.62 0 1.122.478 1.122 1.067v3.7l3.15.785c.542.11.747.32.747.908L22.056 20c-.37 0-.707-.284-.755-.635l-.798-2.676h-.406v1.042l-3.525.085-.97 1.613a.925.925 0 01-.12.196c-.183.227-.47.374-.794.374h-1.35L8.94 17.585 0 17.6zm23.707-3.878c0-.95.811-1.722 1.811-1.722h.676c.185 0 .437.027.605.076.742.216 1.28.87 1.28 1.646v1.013h-.607l-1.219 1.725a.858.858 0 01-1.156.194l-.61-.407v-1.166c0-.094-.075-.243-.17-.346h-.61v-1.013z",
  fill: "currentColor"
})));